"use strict";

exports.__esModule = true;
exports.DATE_PRESETS = void 0;
exports.FormattedPlantDate = FormattedPlantDate;
exports.formatDateString = formatDateString;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _TimeContext = require("../TimeContext");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _excluded = ["value", "formatOptions"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var DATE_PRESETS = exports.DATE_PRESETS = {
  // 2018-10-08 5:01:41
  AllNumericLongDateTime: {
    format: "YYYY-MM-DD hh:mm:ss A"
  },
  // October 8, 2018, 5:01:41
  LongDateTime: {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  },
  // Oct 8, 5:01:41
  ShortMonthDateTime: {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  },
  // Oct 8, 2018 7:00
  ShortDateTime: {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  },
  ShortDate: {
    year: "2-digit",
    month: "short",
    day: "numeric",
    weekday: "short"
  },
  ShortTime: {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  }
};

// Taken from https://github.com/yahoo/react-intl/wiki/Components#formatteddate

function formatDateString(value, formatOptions) {
  if (formatOptions != null && formatOptions.format) {
    return _momentTimezone["default"].tz(value, formatOptions.timeZone).locale("en-us").format("YYYY-MM-DD hh:mm:ss A");
  }
  if (formatOptions) {
    return new Intl.DateTimeFormat("en-us", Object.assign({}, formatOptions)).format(new Date(value));
  }
  return new Intl.DateTimeFormat("en-us", Object.assign({}, DATE_PRESETS.LongDateTime)).format(new Date(value));
}
function FormattedPlantDate(props) {
  var time = _react["default"].useContext(_TimeContext.TimeContext);
  var value = props.value,
    formatOptions = props.formatOptions,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  if (formatOptions) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedDate, _extends({
      value: value,
      timeZone: time.timezone.name
    }, formatOptions, extra));
  }
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedDate, _extends({
    value: value,
    timeZone: time.timezone.name
  }, DATE_PRESETS.LongDateTime, extra));
}